// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ViewMessage-root-lWPEw {
  padding-left: 20px;
  padding-right: 20px;
}

.ViewMessage-container-FO_8m {
  margin: 0px auto;
  padding-top: 30px;
  max-width: var(--max-listing-width);
}

.ViewMessage-bgColor-l3fva {
  width: 100%;
}

@media (max-width:1023px) and (min-width:768px) {
  .ViewMessage-bgColor-l3fva {
    padding: 0 15px;
  }
}

@media (max-width: 767px) {
  .ViewMessage-bgColor-l3fva {
    padding: 0 15px;
  }

  .ViewMessage-root-lWPEw {
    padding-left: 0;
    padding-right: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/viewMessage/ViewMessage.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF","sourcesContent":[".root {\n  padding-left: 20px;\n  padding-right: 20px;\n}\n\n.container {\n  margin: 0px auto;\n  padding-top: 30px;\n  max-width: var(--max-listing-width);\n}\n\n.bgColor {\n  width: 100%;\n}\n\n@media (max-width:1023px) and (min-width:768px) {\n  .bgColor {\n    padding: 0 15px;\n  }\n}\n\n@media (max-width: 767px) {\n  .bgColor {\n    padding: 0 15px;\n  }\n\n  .root {\n    padding-left: 0;\n    padding-right: 0;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `ViewMessage-root-lWPEw`,
	"container": `ViewMessage-container-FO_8m`,
	"bgColor": `ViewMessage-bgColor-l3fva`
};
module.exports = ___CSS_LOADER_EXPORT___;
